(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sdt_product"]) return;
  try {
    
          let swiperThumbnail = null;
          let swiperProducts = null;
          let currentMode = null;

          function cleanupSwiperStyles() {
            document.querySelectorAll('.productsSlide .swiper-wrapper, .productsSlide .swiper-slide, .productsPagination .swiper-wrapper, .productsPagination .swiper-slide').forEach(function(el) {
              el.removeAttribute('style');
            });
          }

          function initProductSwipers() {
            const isMobile = window.innerWidth < 768;
            const nextMode = isMobile ? 'mobile' : 'desktop';

            if (currentMode === nextMode && swiperThumbnail && swiperProducts) {
              return;
            }

            currentMode = nextMode;

            if (swiperProducts) {
              swiperProducts.destroy(true, true);
              swiperProducts = null;
            }

            if (swiperThumbnail) {
              swiperThumbnail.destroy(true, true);
              swiperThumbnail = null;
            }

            cleanupSwiperStyles();

            swiperThumbnail = new Swiper('.productsPagination', {
              spaceBetween: 8,
              watchSlidesVisibility: true,
              watchSlidesProgress: true,

              slidesPerView: isMobile ? 4.5 : 5,
              slidesPerColumn: isMobile ? 1 : 5,
              slidesPerColumnFill: 'row',
              allowTouchMove: isMobile,
              freeMode: isMobile,

              observer: true,
              observeParents: true
            });

            swiperProducts = new Swiper('.productsSlide', {
              loop: true,
              loopedSlides: document.querySelectorAll('.productsPagination .swiper-slide').length,
              thumbs: {
                swiper: swiperThumbnail
              }
            });
          }

          initProductSwipers();

          let resizeTimer = null;
          window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
              initProductSwipers();
            }, 150);
          });

          // jQuery依存を排除した版
          const intervalId = window.setInterval(function() {
            var form = document.querySelector('form#productForm');
            if (!form) return;

            var disabledElements = form.querySelectorAll(':disabled');
            if (disabledElements.length > 0) {
              disabledElements.forEach(function(el) {
                el.removeAttribute('disabled');
              });
              window.clearInterval(intervalId);
            }
          }, 100);
        
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sdt_productN"]) return;
  try {
    
          let swiperThumbnail = null;
          let swiperProducts = null;
          let currentMode = null;

          function cleanupSwiperStyles() {
            document.querySelectorAll('.productsSlide .swiper-wrapper, .productsSlide .swiper-slide, .productsPagination .swiper-wrapper, .productsPagination .swiper-slide').forEach(function(el) {
              el.removeAttribute('style');
            });
          }

          function initProductSwipers() {
            const isMobile = window.innerWidth < 768;
            const nextMode = isMobile ? 'mobile' : 'desktop';

            if (currentMode === nextMode && swiperThumbnail && swiperProducts) {
              return;
            }

            currentMode = nextMode;

            if (swiperProducts) {
              swiperProducts.destroy(true, true);
              swiperProducts = null;
            }

            if (swiperThumbnail) {
              swiperThumbnail.destroy(true, true);
              swiperThumbnail = null;
            }

            cleanupSwiperStyles();

            swiperThumbnail = new Swiper('.productsPagination', {
              spaceBetween: 8,
              watchSlidesVisibility: true,
              watchSlidesProgress: true,

              slidesPerView: isMobile ? 4.5 : 5,
              slidesPerColumn: isMobile ? 1 : 5,
              slidesPerColumnFill: 'row',
              allowTouchMove: isMobile,
              freeMode: isMobile,

              observer: true,
              observeParents: true
            });

            swiperProducts = new Swiper('.productsSlide', {
              loop: true,
              loopedSlides: document.querySelectorAll('.productsPagination .swiper-slide').length,
              thumbs: {
                swiper: swiperThumbnail
              }
            });
          }

          initProductSwipers();

          // SKU選択に合わせてSwiperの画像を切り替え
          const variantMediaMap = JSON.parse(
            document.getElementById('variant-media-map')?.textContent || '{}'
          );

          let lastVariantId = '';

          function updateVariantSwiper() {
            const variantId = new URLSearchParams(
              window.location.search
            ).get('variant');

            if (!variantId || variantId === lastVariantId) return;

            lastVariantId = variantId;

            // SKUに登録された画像IDを取得
            const mediaId = variantMediaMap[variantId];
            if (!mediaId || !swiperProducts) return;

            // 該当画像を検索
            const img = document.querySelector(
              `.productsSlide img[data-media-id="${mediaId}"]`
            );

            if (!img) return;

            const index = Number(img.dataset.imageIndex);

            // Swiperを該当画像に移動
            if (Number.isInteger(index)) {
              swiperProducts.slideToLoop(index, 300);
            }
          }

          // GLOなどによるSKU変更を検出
          function scheduleVariantSwiper() {
            [0, 100, 300, 600].forEach(delay => {
              setTimeout(updateVariantSwiper, delay);
            });
          }

          document.addEventListener('click', function(e) {
            if (e.target.closest('.picArea')) return;
            scheduleVariantSwiper();
          });

          document.addEventListener('change', scheduleVariantSwiper);

          // ブラウザの戻る・進むにも対応
          window.addEventListener('popstate', updateVariantSwiper);

          // 初期表示
          updateVariantSwiper();

          let resizeTimer = null;
          window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
              initProductSwipers();
            }, 150);
          });

          // jQuery依存を排除した版
          const intervalId = window.setInterval(function() {
            var form = document.querySelector('form#productForm');
            if (!form) return;

            var disabledElements = form.querySelectorAll(':disabled');
            if (disabledElements.length > 0) {
              disabledElements.forEach(function(el) {
                el.removeAttribute('disabled');
              });
              window.clearInterval(intervalId);
            }
          }, 100);
        
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sdt_productN_egift"]) return;
  try {
    
          let swiperThumbnail = null;
          let swiperProducts = null;
          let currentMode = null;

          function cleanupSwiperStyles() {
            document.querySelectorAll('.productsSlide .swiper-wrapper, .productsSlide .swiper-slide, .productsPagination .swiper-wrapper, .productsPagination .swiper-slide').forEach(function(el) {
              el.removeAttribute('style');
            });
          }

          function initProductSwipers() {
            const isMobile = window.innerWidth < 768;
            const nextMode = isMobile ? 'mobile' : 'desktop';

            if (currentMode === nextMode && swiperThumbnail && swiperProducts) {
              return;
            }

            currentMode = nextMode;

            if (swiperProducts) {
              swiperProducts.destroy(true, true);
              swiperProducts = null;
            }

            if (swiperThumbnail) {
              swiperThumbnail.destroy(true, true);
              swiperThumbnail = null;
            }

            cleanupSwiperStyles();

            swiperThumbnail = new Swiper('.productsPagination', {
              spaceBetween: 8,
              watchSlidesVisibility: true,
              watchSlidesProgress: true,

              slidesPerView: isMobile ? 4.5 : 5,
              slidesPerColumn: isMobile ? 1 : 5,
              slidesPerColumnFill: 'row',
              allowTouchMove: isMobile,
              freeMode: isMobile,

              observer: true,
              observeParents: true
            });

            swiperProducts = new Swiper('.productsSlide', {
              loop: true,
              loopedSlides: document.querySelectorAll('.productsPagination .swiper-slide').length,
              thumbs: {
                swiper: swiperThumbnail
              }
            });
          }

          initProductSwipers();

          // SKU選択に合わせてSwiperの画像を切り替え
          const variantMediaMap = JSON.parse(
            document.getElementById('variant-media-map')?.textContent || '{}'
          );

          let lastVariantId = '';

          function updateVariantSwiper() {
            const variantId = new URLSearchParams(
              window.location.search
            ).get('variant');

            if (!variantId || variantId === lastVariantId) return;

            lastVariantId = variantId;

            // SKUに登録された画像IDを取得
            const mediaId = variantMediaMap[variantId];
            if (!mediaId || !swiperProducts) return;

            // 該当画像を検索
            const img = document.querySelector(
              `.productsSlide img[data-media-id="${mediaId}"]`
            );

            if (!img) return;

            const index = Number(img.dataset.imageIndex);

            // Swiperを該当画像に移動
            if (Number.isInteger(index)) {
              swiperProducts.slideToLoop(index, 300);
            }
          }

          // GLOなどによるSKU変更を検出
          function scheduleVariantSwiper() {
            [0, 100, 300, 600].forEach(delay => {
              setTimeout(updateVariantSwiper, delay);
            });
          }

          document.addEventListener('click', function(e) {
            if (e.target.closest('.picArea')) return;
            scheduleVariantSwiper();
          });

          document.addEventListener('change', scheduleVariantSwiper);

          // ブラウザの戻る・進むにも対応
          window.addEventListener('popstate', updateVariantSwiper);

          // 初期表示
          updateVariantSwiper();

          let resizeTimer = null;
          window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
              initProductSwipers();
            }, 150);
          });

          // jQuery依存を排除した版
          const intervalId = window.setInterval(function() {
            var form = document.querySelector('form#productForm');
            if (!form) return;

            var disabledElements = form.querySelectorAll(':disabled');
            if (disabledElements.length > 0) {
              disabledElements.forEach(function(el) {
                el.removeAttribute('disabled');
              });
              window.clearInterval(intervalId);
            }
          }, 100);
        
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sdt_product_box"]) return;
  try {
    
          let swiperThumbnail = null;
          let swiperProducts = null;
          let currentMode = null;

          function cleanupSwiperStyles() {
            document.querySelectorAll('.productsSlide .swiper-wrapper, .productsSlide .swiper-slide, .productsPagination .swiper-wrapper, .productsPagination .swiper-slide').forEach(function(el) {
              el.removeAttribute('style');
            });
          }

          function initProductSwipers() {
            const isMobile = window.innerWidth < 768;
            const nextMode = isMobile ? 'mobile' : 'desktop';

            if (currentMode === nextMode && swiperThumbnail && swiperProducts) {
              return;
            }

            currentMode = nextMode;

            if (swiperProducts) {
              swiperProducts.destroy(true, true);
              swiperProducts = null;
            }

            if (swiperThumbnail) {
              swiperThumbnail.destroy(true, true);
              swiperThumbnail = null;
            }

            cleanupSwiperStyles();

            swiperThumbnail = new Swiper('.productsPagination', {
              spaceBetween: 8,
              watchSlidesVisibility: true,
              watchSlidesProgress: true,

              slidesPerView: isMobile ? 4.5 : 5,
              slidesPerColumn: isMobile ? 1 : 5,
              slidesPerColumnFill: 'row',
              allowTouchMove: isMobile,
              freeMode: isMobile,

              observer: true,
              observeParents: true
            });

            swiperProducts = new Swiper('.productsSlide', {
              loop: true,
              loopedSlides: document.querySelectorAll('.productsPagination .swiper-slide').length,
              thumbs: {
                swiper: swiperThumbnail
              }
            });
          }

          initProductSwipers();

          let resizeTimer = null;
          window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
              initProductSwipers();
            }, 150);
          });

          // jQuery依存を排除した版
          const intervalId = window.setInterval(function() {
            var form = document.querySelector('form#productForm');
            if (!form) return;

            var disabledElements = form.querySelectorAll(':disabled');
            if (disabledElements.length > 0) {
              disabledElements.forEach(function(el) {
                el.removeAttribute('disabled');
              });
              window.clearInterval(intervalId);
            }
          }, 100);
        
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sdt_product_dark"]) return;
  try {
    
          let swiperThumbnail = null;
          let swiperProducts = null;
          let currentMode = null;

          function cleanupSwiperStyles() {
            document.querySelectorAll('.productsSlide .swiper-wrapper, .productsSlide .swiper-slide, .productsPagination .swiper-wrapper, .productsPagination .swiper-slide').forEach(function(el) {
              el.removeAttribute('style');
            });
          }

          function initProductSwipers() {
            const isMobile = window.innerWidth < 768;
            const nextMode = isMobile ? 'mobile' : 'desktop';

            if (currentMode === nextMode && swiperThumbnail && swiperProducts) {
              return;
            }

            currentMode = nextMode;

            if (swiperProducts) {
              swiperProducts.destroy(true, true);
              swiperProducts = null;
            }

            if (swiperThumbnail) {
              swiperThumbnail.destroy(true, true);
              swiperThumbnail = null;
            }

            cleanupSwiperStyles();

            swiperThumbnail = new Swiper('.productsPagination', {
              spaceBetween: 8,
              watchSlidesVisibility: true,
              watchSlidesProgress: true,

              slidesPerView: isMobile ? 4.5 : 5,
              slidesPerColumn: isMobile ? 1 : 5,
              slidesPerColumnFill: 'row',
              allowTouchMove: isMobile,
              freeMode: isMobile,

              observer: true,
              observeParents: true
            });

            swiperProducts = new Swiper('.productsSlide', {
              loop: true,
              loopedSlides: document.querySelectorAll('.productsPagination .swiper-slide').length,
              thumbs: {
                swiper: swiperThumbnail
              }
            });
          }

          initProductSwipers();

          let resizeTimer = null;
          window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
              initProductSwipers();
            }, 150);
          });

          // jQuery依存を排除した版
          const intervalId = window.setInterval(function() {
            var form = document.querySelector('form#productForm');
            if (!form) return;

            var disabledElements = form.querySelectorAll(':disabled');
            if (disabledElements.length > 0) {
              disabledElements.forEach(function(el) {
                el.removeAttribute('disabled');
              });
              window.clearInterval(intervalId);
            }
          }, 100);
        
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sdt_product_darkN"]) return;
  try {
    
          let swiperThumbnail = null;
          let swiperProducts = null;
          let currentMode = null;

          function cleanupSwiperStyles() {
            document.querySelectorAll('.productsSlide .swiper-wrapper, .productsSlide .swiper-slide, .productsPagination .swiper-wrapper, .productsPagination .swiper-slide').forEach(function(el) {
              el.removeAttribute('style');
            });
          }

          function initProductSwipers() {
            const isMobile = window.innerWidth < 768;
            const nextMode = isMobile ? 'mobile' : 'desktop';

            if (currentMode === nextMode && swiperThumbnail && swiperProducts) {
              return;
            }

            currentMode = nextMode;

            if (swiperProducts) {
              swiperProducts.destroy(true, true);
              swiperProducts = null;
            }

            if (swiperThumbnail) {
              swiperThumbnail.destroy(true, true);
              swiperThumbnail = null;
            }

            cleanupSwiperStyles();

            swiperThumbnail = new Swiper('.productsPagination', {
              spaceBetween: 8,
              watchSlidesVisibility: true,
              watchSlidesProgress: true,

              slidesPerView: isMobile ? 4.5 : 5,
              slidesPerColumn: isMobile ? 1 : 5,
              slidesPerColumnFill: 'row',
              allowTouchMove: isMobile,
              freeMode: isMobile,

              observer: true,
              observeParents: true
            });

            swiperProducts = new Swiper('.productsSlide', {
              loop: true,
              loopedSlides: document.querySelectorAll('.productsPagination .swiper-slide').length,
              thumbs: {
                swiper: swiperThumbnail
              }
            });
          }

          initProductSwipers();

          let resizeTimer = null;
          window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
              initProductSwipers();
            }, 150);
          });

          // jQuery依存を排除した版
          const intervalId = window.setInterval(function() {
            var form = document.querySelector('form#productForm');
            if (!form) return;

            var disabledElements = form.querySelectorAll(':disabled');
            if (disabledElements.length > 0) {
              disabledElements.forEach(function(el) {
                el.removeAttribute('disabled');
              });
              window.clearInterval(intervalId);
            }
          }, 100);
        
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sdt_product_darkN_egift"]) return;
  try {
    
          let swiperThumbnail = null;
          let swiperProducts = null;
          let currentMode = null;

          function cleanupSwiperStyles() {
            document.querySelectorAll('.productsSlide .swiper-wrapper, .productsSlide .swiper-slide, .productsPagination .swiper-wrapper, .productsPagination .swiper-slide').forEach(function(el) {
              el.removeAttribute('style');
            });
          }

          function initProductSwipers() {
            const isMobile = window.innerWidth < 768;
            const nextMode = isMobile ? 'mobile' : 'desktop';

            if (currentMode === nextMode && swiperThumbnail && swiperProducts) {
              return;
            }

            currentMode = nextMode;

            if (swiperProducts) {
              swiperProducts.destroy(true, true);
              swiperProducts = null;
            }

            if (swiperThumbnail) {
              swiperThumbnail.destroy(true, true);
              swiperThumbnail = null;
            }

            cleanupSwiperStyles();

            swiperThumbnail = new Swiper('.productsPagination', {
              spaceBetween: 8,
              watchSlidesVisibility: true,
              watchSlidesProgress: true,

              slidesPerView: isMobile ? 4.5 : 5,
              slidesPerColumn: isMobile ? 1 : 5,
              slidesPerColumnFill: 'row',
              allowTouchMove: isMobile,
              freeMode: isMobile,

              observer: true,
              observeParents: true
            });

            swiperProducts = new Swiper('.productsSlide', {
              loop: true,
              loopedSlides: document.querySelectorAll('.productsPagination .swiper-slide').length,
              thumbs: {
                swiper: swiperThumbnail
              }
            });
          }

          initProductSwipers();

          let resizeTimer = null;
          window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
              initProductSwipers();
            }, 150);
          });

          // jQuery依存を排除した版
          const intervalId = window.setInterval(function() {
            var form = document.querySelector('form#productForm');
            if (!form) return;

            var disabledElements = form.querySelectorAll(':disabled');
            if (disabledElements.length > 0) {
              disabledElements.forEach(function(el) {
                el.removeAttribute('disabled');
              });
              window.clearInterval(intervalId);
            }
          }, 100);
        
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sdt_product_dark_egift"]) return;
  try {
    
          let swiperThumbnail = null;
          let swiperProducts = null;
          let currentMode = null;

          function cleanupSwiperStyles() {
            document.querySelectorAll('.productsSlide .swiper-wrapper, .productsSlide .swiper-slide, .productsPagination .swiper-wrapper, .productsPagination .swiper-slide').forEach(function(el) {
              el.removeAttribute('style');
            });
          }

          function initProductSwipers() {
            const isMobile = window.innerWidth < 768;
            const nextMode = isMobile ? 'mobile' : 'desktop';

            if (currentMode === nextMode && swiperThumbnail && swiperProducts) {
              return;
            }

            currentMode = nextMode;

            if (swiperProducts) {
              swiperProducts.destroy(true, true);
              swiperProducts = null;
            }

            if (swiperThumbnail) {
              swiperThumbnail.destroy(true, true);
              swiperThumbnail = null;
            }

            cleanupSwiperStyles();

            swiperThumbnail = new Swiper('.productsPagination', {
              spaceBetween: 8,
              watchSlidesVisibility: true,
              watchSlidesProgress: true,

              slidesPerView: isMobile ? 4.5 : 5,
              slidesPerColumn: isMobile ? 1 : 5,
              slidesPerColumnFill: 'row',
              allowTouchMove: isMobile,
              freeMode: isMobile,

              observer: true,
              observeParents: true
            });

            swiperProducts = new Swiper('.productsSlide', {
              loop: true,
              loopedSlides: document.querySelectorAll('.productsPagination .swiper-slide').length,
              thumbs: {
                swiper: swiperThumbnail
              }
            });
          }

          initProductSwipers();

          let resizeTimer = null;
          window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
              initProductSwipers();
            }, 150);
          });

          // jQuery依存を排除した版
          const intervalId = window.setInterval(function() {
            var form = document.querySelector('form#productForm');
            if (!form) return;

            var disabledElements = form.querySelectorAll(':disabled');
            if (disabledElements.length > 0) {
              disabledElements.forEach(function(el) {
                el.removeAttribute('disabled');
              });
              window.clearInterval(intervalId);
            }
          }, 100);
        
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sdt_product_dark_pulldown"]) return;
  try {
    
          let swiperThumbnail = null;
          let swiperProducts = null;
          let currentMode = null;

          function cleanupSwiperStyles() {
            document.querySelectorAll('.productsSlide .swiper-wrapper, .productsSlide .swiper-slide, .productsPagination .swiper-wrapper, .productsPagination .swiper-slide').forEach(function(el) {
              el.removeAttribute('style');
            });
          }

          function initProductSwipers() {
            const isMobile = window.innerWidth < 768;
            const nextMode = isMobile ? 'mobile' : 'desktop';

            if (currentMode === nextMode && swiperThumbnail && swiperProducts) {
              return;
            }

            currentMode = nextMode;

            if (swiperProducts) {
              swiperProducts.destroy(true, true);
              swiperProducts = null;
            }

            if (swiperThumbnail) {
              swiperThumbnail.destroy(true, true);
              swiperThumbnail = null;
            }

            cleanupSwiperStyles();

            swiperThumbnail = new Swiper('.productsPagination', {
              spaceBetween: 8,
              watchSlidesVisibility: true,
              watchSlidesProgress: true,

              slidesPerView: isMobile ? 4.5 : 5,
              slidesPerColumn: isMobile ? 1 : 5,
              slidesPerColumnFill: 'row',
              allowTouchMove: isMobile,
              freeMode: isMobile,

              observer: true,
              observeParents: true
            });

            swiperProducts = new Swiper('.productsSlide', {
              loop: true,
              loopedSlides: document.querySelectorAll('.productsPagination .swiper-slide').length,
              thumbs: {
                swiper: swiperThumbnail
              }
            });
          }

          initProductSwipers();

          let resizeTimer = null;
          window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
              initProductSwipers();
            }, 150);
          });

          // jQuery依存を排除した版
          const intervalId = window.setInterval(function() {
            var form = document.querySelector('form#productForm');
            if (!form) return;

            var disabledElements = form.querySelectorAll(':disabled');
            if (disabledElements.length > 0) {
              disabledElements.forEach(function(el) {
                el.removeAttribute('disabled');
              });
              window.clearInterval(intervalId);
            }
          }, 100);
        
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sdt_product_designed_egift"]) return;
  try {
    
          let swiperThumbnail = null;
          let swiperProducts = null;
          let currentMode = null;

          function cleanupSwiperStyles() {
            document.querySelectorAll('.productsSlide .swiper-wrapper, .productsSlide .swiper-slide, .productsPagination .swiper-wrapper, .productsPagination .swiper-slide').forEach(function(el) {
              el.removeAttribute('style');
            });
          }

          function initProductSwipers() {
            const isMobile = window.innerWidth < 768;
            const nextMode = isMobile ? 'mobile' : 'desktop';

            if (currentMode === nextMode && swiperThumbnail && swiperProducts) {
              return;
            }

            currentMode = nextMode;

            if (swiperProducts) {
              swiperProducts.destroy(true, true);
              swiperProducts = null;
            }

            if (swiperThumbnail) {
              swiperThumbnail.destroy(true, true);
              swiperThumbnail = null;
            }

            cleanupSwiperStyles();

            swiperThumbnail = new Swiper('.productsPagination', {
              spaceBetween: 8,
              watchSlidesVisibility: true,
              watchSlidesProgress: true,

              slidesPerView: isMobile ? 4.5 : 5,
              slidesPerColumn: isMobile ? 1 : 5,
              slidesPerColumnFill: 'row',
              allowTouchMove: isMobile,
              freeMode: isMobile,

              observer: true,
              observeParents: true
            });

            swiperProducts = new Swiper('.productsSlide', {
              loop: true,
              loopedSlides: document.querySelectorAll('.productsPagination .swiper-slide').length,
              thumbs: {
                swiper: swiperThumbnail
              }
            });
          }

          initProductSwipers();

          let resizeTimer = null;
          window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
              initProductSwipers();
            }, 150);
          });

          // jQuery依存を排除した版
          const intervalId = window.setInterval(function() {
            var form = document.querySelector('form#productForm');
            if (!form) return;

            var disabledElements = form.querySelectorAll(':disabled');
            if (disabledElements.length > 0) {
              disabledElements.forEach(function(el) {
                el.removeAttribute('disabled');
              });
              window.clearInterval(intervalId);
            }
          }, 100);
        
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sdt_product_egift"]) return;
  try {
    
          let swiperThumbnail = null;
          let swiperProducts = null;
          let currentMode = null;

          function cleanupSwiperStyles() {
            document.querySelectorAll('.productsSlide .swiper-wrapper, .productsSlide .swiper-slide, .productsPagination .swiper-wrapper, .productsPagination .swiper-slide').forEach(function(el) {
              el.removeAttribute('style');
            });
          }

          function initProductSwipers() {
            const isMobile = window.innerWidth < 768;
            const nextMode = isMobile ? 'mobile' : 'desktop';

            if (currentMode === nextMode && swiperThumbnail && swiperProducts) {
              return;
            }

            currentMode = nextMode;

            if (swiperProducts) {
              swiperProducts.destroy(true, true);
              swiperProducts = null;
            }

            if (swiperThumbnail) {
              swiperThumbnail.destroy(true, true);
              swiperThumbnail = null;
            }

            cleanupSwiperStyles();

            swiperThumbnail = new Swiper('.productsPagination', {
              spaceBetween: 8,
              watchSlidesVisibility: true,
              watchSlidesProgress: true,

              slidesPerView: isMobile ? 4.5 : 5,
              slidesPerColumn: isMobile ? 1 : 5,
              slidesPerColumnFill: 'row',
              allowTouchMove: isMobile,
              freeMode: isMobile,

              observer: true,
              observeParents: true
            });

            swiperProducts = new Swiper('.productsSlide', {
              loop: true,
              loopedSlides: document.querySelectorAll('.productsPagination .swiper-slide').length,
              thumbs: {
                swiper: swiperThumbnail
              }
            });
          }

          initProductSwipers();

          let resizeTimer = null;
          window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
              initProductSwipers();
            }, 150);
          });

          // jQuery依存を排除した版
          const intervalId = window.setInterval(function() {
            var form = document.querySelector('form#productForm');
            if (!form) return;

            var disabledElements = form.querySelectorAll(':disabled');
            if (disabledElements.length > 0) {
              disabledElements.forEach(function(el) {
                el.removeAttribute('disabled');
              });
              window.clearInterval(intervalId);
            }
          }, 100);
        
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sdt_product_egift_dark"]) return;
  try {
    
          let swiperThumbnail = null;
          let swiperProducts = null;
          let currentMode = null;

          function cleanupSwiperStyles() {
            document.querySelectorAll('.productsSlide .swiper-wrapper, .productsSlide .swiper-slide, .productsPagination .swiper-wrapper, .productsPagination .swiper-slide').forEach(function(el) {
              el.removeAttribute('style');
            });
          }

          function initProductSwipers() {
            const isMobile = window.innerWidth < 768;
            const nextMode = isMobile ? 'mobile' : 'desktop';

            if (currentMode === nextMode && swiperThumbnail && swiperProducts) {
              return;
            }

            currentMode = nextMode;

            if (swiperProducts) {
              swiperProducts.destroy(true, true);
              swiperProducts = null;
            }

            if (swiperThumbnail) {
              swiperThumbnail.destroy(true, true);
              swiperThumbnail = null;
            }

            cleanupSwiperStyles();

            swiperThumbnail = new Swiper('.productsPagination', {
              spaceBetween: 8,
              watchSlidesVisibility: true,
              watchSlidesProgress: true,

              slidesPerView: isMobile ? 4.5 : 5,
              slidesPerColumn: isMobile ? 1 : 5,
              slidesPerColumnFill: 'row',
              allowTouchMove: isMobile,
              freeMode: isMobile,

              observer: true,
              observeParents: true
            });

            swiperProducts = new Swiper('.productsSlide', {
              loop: true,
              loopedSlides: document.querySelectorAll('.productsPagination .swiper-slide').length,
              thumbs: {
                swiper: swiperThumbnail
              }
            });
          }

          initProductSwipers();

          let resizeTimer = null;
          window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
              initProductSwipers();
            }, 150);
          });

          // jQuery依存を排除した版
          const intervalId = window.setInterval(function() {
            var form = document.querySelector('form#productForm');
            if (!form) return;

            var disabledElements = form.querySelectorAll(':disabled');
            if (disabledElements.length > 0) {
              disabledElements.forEach(function(el) {
                el.removeAttribute('disabled');
              });
              window.clearInterval(intervalId);
            }
          }, 100);
        
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sdt_product_pulldown"]) return;
  try {
    
          let swiperThumbnail = null;
          let swiperProducts = null;
          let currentMode = null;

          function cleanupSwiperStyles() {
            document.querySelectorAll('.productsSlide .swiper-wrapper, .productsSlide .swiper-slide, .productsPagination .swiper-wrapper, .productsPagination .swiper-slide').forEach(function(el) {
              el.removeAttribute('style');
            });
          }

          function initProductSwipers() {
            const isMobile = window.innerWidth < 768;
            const nextMode = isMobile ? 'mobile' : 'desktop';

            if (currentMode === nextMode && swiperThumbnail && swiperProducts) {
              return;
            }

            currentMode = nextMode;

            if (swiperProducts) {
              swiperProducts.destroy(true, true);
              swiperProducts = null;
            }

            if (swiperThumbnail) {
              swiperThumbnail.destroy(true, true);
              swiperThumbnail = null;
            }

            cleanupSwiperStyles();

            swiperThumbnail = new Swiper('.productsPagination', {
              spaceBetween: 8,
              watchSlidesVisibility: true,
              watchSlidesProgress: true,

              slidesPerView: isMobile ? 4.5 : 5,
              slidesPerColumn: isMobile ? 1 : 5,
              slidesPerColumnFill: 'row',
              allowTouchMove: isMobile,
              freeMode: isMobile,

              observer: true,
              observeParents: true
            });

            swiperProducts = new Swiper('.productsSlide', {
              loop: true,
              loopedSlides: document.querySelectorAll('.productsPagination .swiper-slide').length,
              thumbs: {
                swiper: swiperThumbnail
              }
            });
          }

          initProductSwipers();

          let resizeTimer = null;
          window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
              initProductSwipers();
            }, 150);
          });

          // jQuery依存を排除した版
          const intervalId = window.setInterval(function() {
            var form = document.querySelector('form#productForm');
            if (!form) return;

            var disabledElements = form.querySelectorAll(':disabled');
            if (disabledElements.length > 0) {
              disabledElements.forEach(function(el) {
                el.removeAttribute('disabled');
              });
              window.clearInterval(intervalId);
            }
          }, 100);
        
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sdt_product_select1"]) return;
  try {
    
          let swiperThumbnail = null;
          let swiperProducts = null;
          let currentMode = null;

          function cleanupSwiperStyles() {
            document.querySelectorAll('.productsSlide .swiper-wrapper, .productsSlide .swiper-slide, .productsPagination .swiper-wrapper, .productsPagination .swiper-slide').forEach(function(el) {
              el.removeAttribute('style');
            });
          }

          function initProductSwipers() {
            const isMobile = window.innerWidth < 768;
            const nextMode = isMobile ? 'mobile' : 'desktop';

            if (currentMode === nextMode && swiperThumbnail && swiperProducts) {
              return;
            }

            currentMode = nextMode;

            if (swiperProducts) {
              swiperProducts.destroy(true, true);
              swiperProducts = null;
            }

            if (swiperThumbnail) {
              swiperThumbnail.destroy(true, true);
              swiperThumbnail = null;
            }

            cleanupSwiperStyles();

            swiperThumbnail = new Swiper('.productsPagination', {
              spaceBetween: 8,
              watchSlidesVisibility: true,
              watchSlidesProgress: true,

              slidesPerView: isMobile ? 4.5 : 5,
              slidesPerColumn: isMobile ? 1 : 5,
              slidesPerColumnFill: 'row',
              allowTouchMove: isMobile,
              freeMode: isMobile,

              observer: true,
              observeParents: true
            });

            swiperProducts = new Swiper('.productsSlide', {
              loop: true,
              loopedSlides: document.querySelectorAll('.productsPagination .swiper-slide').length,
              thumbs: {
                swiper: swiperThumbnail
              }
            });
          }

          initProductSwipers();

          let resizeTimer = null;
          window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
              initProductSwipers();
            }, 150);
          });

          // jQuery依存を排除した版
          const intervalId = window.setInterval(function() {
            var form = document.querySelector('form#productForm');
            if (!form) return;

            var disabledElements = form.querySelectorAll(':disabled');
            if (disabledElements.length > 0) {
              disabledElements.forEach(function(el) {
                el.removeAttribute('disabled');
              });
              window.clearInterval(intervalId);
            }
          }, 100);
        
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sdt_product_select3"]) return;
  try {
    
          let swiperThumbnail = null;
          let swiperProducts = null;
          let currentMode = null;

          function cleanupSwiperStyles() {
            document.querySelectorAll('.productsSlide .swiper-wrapper, .productsSlide .swiper-slide, .productsPagination .swiper-wrapper, .productsPagination .swiper-slide').forEach(function(el) {
              el.removeAttribute('style');
            });
          }

          function initProductSwipers() {
            const isMobile = window.innerWidth < 768;
            const nextMode = isMobile ? 'mobile' : 'desktop';

            if (currentMode === nextMode && swiperThumbnail && swiperProducts) {
              return;
            }

            currentMode = nextMode;

            if (swiperProducts) {
              swiperProducts.destroy(true, true);
              swiperProducts = null;
            }

            if (swiperThumbnail) {
              swiperThumbnail.destroy(true, true);
              swiperThumbnail = null;
            }

            cleanupSwiperStyles();

            swiperThumbnail = new Swiper('.productsPagination', {
              spaceBetween: 8,
              watchSlidesVisibility: true,
              watchSlidesProgress: true,

              slidesPerView: isMobile ? 4.5 : 5,
              slidesPerColumn: isMobile ? 1 : 5,
              slidesPerColumnFill: 'row',
              allowTouchMove: isMobile,
              freeMode: isMobile,

              observer: true,
              observeParents: true
            });

            swiperProducts = new Swiper('.productsSlide', {
              loop: true,
              loopedSlides: document.querySelectorAll('.productsPagination .swiper-slide').length,
              thumbs: {
                swiper: swiperThumbnail
              }
            });
          }

          initProductSwipers();

          let resizeTimer = null;
          window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
              initProductSwipers();
            }, 150);
          });

          // jQuery依存を排除した版
          const intervalId = window.setInterval(function() {
            var form = document.querySelector('form#productForm');
            if (!form) return;

            var disabledElements = form.querySelectorAll(':disabled');
            if (disabledElements.length > 0) {
              disabledElements.forEach(function(el) {
                el.removeAttribute('disabled');
              });
              window.clearInterval(intervalId);
            }
          }, 100);
        
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sdt_product_select3_pulldown"]) return;
  try {
    
          let swiperThumbnail = null;
          let swiperProducts = null;
          let currentMode = null;

          function cleanupSwiperStyles() {
            document.querySelectorAll('.productsSlide .swiper-wrapper, .productsSlide .swiper-slide, .productsPagination .swiper-wrapper, .productsPagination .swiper-slide').forEach(function(el) {
              el.removeAttribute('style');
            });
          }

          function initProductSwipers() {
            const isMobile = window.innerWidth < 768;
            const nextMode = isMobile ? 'mobile' : 'desktop';

            if (currentMode === nextMode && swiperThumbnail && swiperProducts) {
              return;
            }

            currentMode = nextMode;

            if (swiperProducts) {
              swiperProducts.destroy(true, true);
              swiperProducts = null;
            }

            if (swiperThumbnail) {
              swiperThumbnail.destroy(true, true);
              swiperThumbnail = null;
            }

            cleanupSwiperStyles();

            swiperThumbnail = new Swiper('.productsPagination', {
              spaceBetween: 8,
              watchSlidesVisibility: true,
              watchSlidesProgress: true,

              slidesPerView: isMobile ? 4.5 : 5,
              slidesPerColumn: isMobile ? 1 : 5,
              slidesPerColumnFill: 'row',
              allowTouchMove: isMobile,
              freeMode: isMobile,

              observer: true,
              observeParents: true
            });

            swiperProducts = new Swiper('.productsSlide', {
              loop: true,
              loopedSlides: document.querySelectorAll('.productsPagination .swiper-slide').length,
              thumbs: {
                swiper: swiperThumbnail
              }
            });
          }

          initProductSwipers();

          let resizeTimer = null;
          window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
              initProductSwipers();
            }, 150);
          });

          // jQuery依存を排除した版
          const intervalId = window.setInterval(function() {
            var form = document.querySelector('form#productForm');
            if (!form) return;

            var disabledElements = form.querySelectorAll(':disabled');
            if (disabledElements.length > 0) {
              disabledElements.forEach(function(el) {
                el.removeAttribute('disabled');
              });
              window.clearInterval(intervalId);
            }
          }, 100);
        
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sdt_product_sfm"]) return;
  try {
    
          let swiperThumbnail = null;
          let swiperProducts = null;
          let currentMode = null;

          function cleanupSwiperStyles() {
            document.querySelectorAll('.productsSlide .swiper-wrapper, .productsSlide .swiper-slide, .productsPagination .swiper-wrapper, .productsPagination .swiper-slide').forEach(function(el) {
              el.removeAttribute('style');
            });
          }

          function initProductSwipers() {
            const isMobile = window.innerWidth < 768;
            const nextMode = isMobile ? 'mobile' : 'desktop';

            if (currentMode === nextMode && swiperThumbnail && swiperProducts) {
              return;
            }

            currentMode = nextMode;

            if (swiperProducts) {
              swiperProducts.destroy(true, true);
              swiperProducts = null;
            }

            if (swiperThumbnail) {
              swiperThumbnail.destroy(true, true);
              swiperThumbnail = null;
            }

            cleanupSwiperStyles();

            swiperThumbnail = new Swiper('.productsPagination', {
              spaceBetween: 8,
              watchSlidesVisibility: true,
              watchSlidesProgress: true,

              slidesPerView: isMobile ? 4.5 : 5,
              slidesPerColumn: isMobile ? 1 : 5,
              slidesPerColumnFill: 'row',
              allowTouchMove: isMobile,
              freeMode: isMobile,

              observer: true,
              observeParents: true
            });

            swiperProducts = new Swiper('.productsSlide', {
              loop: true,
              loopedSlides: document.querySelectorAll('.productsPagination .swiper-slide').length,
              thumbs: {
                swiper: swiperThumbnail
              }
            });
          }

          initProductSwipers();

          let resizeTimer = null;
          window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
              initProductSwipers();
            }, 150);
          });

          // jQuery依存を排除した版
          const intervalId = window.setInterval(function() {
            var form = document.querySelector('form#productForm');
            if (!form) return;

            var disabledElements = form.querySelectorAll(':disabled');
            if (disabledElements.length > 0) {
              disabledElements.forEach(function(el) {
                el.removeAttribute('disabled');
              });
              window.clearInterval(intervalId);
            }
          }, 100);
        
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sdt_product_sfm_outlet"]) return;
  try {
    
          let swiperThumbnail = null;
          let swiperProducts = null;
          let currentMode = null;

          function cleanupSwiperStyles() {
            document.querySelectorAll('.productsSlide .swiper-wrapper, .productsSlide .swiper-slide, .productsPagination .swiper-wrapper, .productsPagination .swiper-slide').forEach(function(el) {
              el.removeAttribute('style');
            });
          }

          function initProductSwipers() {
            const isMobile = window.innerWidth < 768;
            const nextMode = isMobile ? 'mobile' : 'desktop';

            if (currentMode === nextMode && swiperThumbnail && swiperProducts) {
              return;
            }

            currentMode = nextMode;

            if (swiperProducts) {
              swiperProducts.destroy(true, true);
              swiperProducts = null;
            }

            if (swiperThumbnail) {
              swiperThumbnail.destroy(true, true);
              swiperThumbnail = null;
            }

            cleanupSwiperStyles();

            swiperThumbnail = new Swiper('.productsPagination', {
              spaceBetween: 8,
              watchSlidesVisibility: true,
              watchSlidesProgress: true,

              slidesPerView: isMobile ? 4.5 : 5,
              slidesPerColumn: isMobile ? 1 : 5,
              slidesPerColumnFill: 'row',
              allowTouchMove: isMobile,
              freeMode: isMobile,

              observer: true,
              observeParents: true
            });

            swiperProducts = new Swiper('.productsSlide', {
              loop: true,
              loopedSlides: document.querySelectorAll('.productsPagination .swiper-slide').length,
              thumbs: {
                swiper: swiperThumbnail
              }
            });
          }

          initProductSwipers();

          let resizeTimer = null;
          window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
              initProductSwipers();
            }, 150);
          });

          // jQuery依存を排除した版
          const intervalId = window.setInterval(function() {
            var form = document.querySelector('form#productForm');
            if (!form) return;

            var disabledElements = form.querySelectorAll(':disabled');
            if (disabledElements.length > 0) {
              disabledElements.forEach(function(el) {
                el.removeAttribute('disabled');
              });
              window.clearInterval(intervalId);
            }
          }, 100);
        
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sdt_product_sfm_outletN"]) return;
  try {
    
          let swiperThumbnail = null;
          let swiperProducts = null;
          let currentMode = null;

          function cleanupSwiperStyles() {
            document.querySelectorAll('.productsSlide .swiper-wrapper, .productsSlide .swiper-slide, .productsPagination .swiper-wrapper, .productsPagination .swiper-slide').forEach(function(el) {
              el.removeAttribute('style');
            });
          }

          function initProductSwipers() {
            const isMobile = window.innerWidth < 768;
            const nextMode = isMobile ? 'mobile' : 'desktop';

            if (currentMode === nextMode && swiperThumbnail && swiperProducts) {
              return;
            }

            currentMode = nextMode;

            if (swiperProducts) {
              swiperProducts.destroy(true, true);
              swiperProducts = null;
            }

            if (swiperThumbnail) {
              swiperThumbnail.destroy(true, true);
              swiperThumbnail = null;
            }

            cleanupSwiperStyles();

            swiperThumbnail = new Swiper('.productsPagination', {
              spaceBetween: 8,
              watchSlidesVisibility: true,
              watchSlidesProgress: true,

              slidesPerView: isMobile ? 4.5 : 5,
              slidesPerColumn: isMobile ? 1 : 5,
              slidesPerColumnFill: 'row',
              allowTouchMove: isMobile,
              freeMode: isMobile,

              observer: true,
              observeParents: true
            });

            swiperProducts = new Swiper('.productsSlide', {
              loop: true,
              loopedSlides: document.querySelectorAll('.productsPagination .swiper-slide').length,
              thumbs: {
                swiper: swiperThumbnail
              }
            });
          }

          initProductSwipers();

          let resizeTimer = null;
          window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
              initProductSwipers();
            }, 150);
          });

          // jQuery依存を排除した版
          const intervalId = window.setInterval(function() {
            var form = document.querySelector('form#productForm');
            if (!form) return;

            var disabledElements = form.querySelectorAll(':disabled');
            if (disabledElements.length > 0) {
              disabledElements.forEach(function(el) {
                el.removeAttribute('disabled');
              });
              window.clearInterval(intervalId);
            }
          }, 100);
        
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sdt_product_workshop"]) return;
  try {
    
          let swiperThumbnail = null;
          let swiperProducts = null;
          let currentMode = null;

          function cleanupSwiperStyles() {
            document.querySelectorAll('.productsSlide .swiper-wrapper, .productsSlide .swiper-slide, .productsPagination .swiper-wrapper, .productsPagination .swiper-slide').forEach(function(el) {
              el.removeAttribute('style');
            });
          }

          function initProductSwipers() {
            const isMobile = window.innerWidth < 768;
            const nextMode = isMobile ? 'mobile' : 'desktop';

            if (currentMode === nextMode && swiperThumbnail && swiperProducts) {
              return;
            }

            currentMode = nextMode;

            if (swiperProducts) {
              swiperProducts.destroy(true, true);
              swiperProducts = null;
            }

            if (swiperThumbnail) {
              swiperThumbnail.destroy(true, true);
              swiperThumbnail = null;
            }

            cleanupSwiperStyles();

            swiperThumbnail = new Swiper('.productsPagination', {
              spaceBetween: 8,
              watchSlidesVisibility: true,
              watchSlidesProgress: true,

              slidesPerView: isMobile ? 4.5 : 5,
              slidesPerColumn: isMobile ? 1 : 5,
              slidesPerColumnFill: 'row',
              allowTouchMove: isMobile,
              freeMode: isMobile,

              observer: true,
              observeParents: true
            });

            swiperProducts = new Swiper('.productsSlide', {
              loop: true,
              loopedSlides: document.querySelectorAll('.productsPagination .swiper-slide').length,
              thumbs: {
                swiper: swiperThumbnail
              }
            });
          }

          initProductSwipers();

          let resizeTimer = null;
          window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
              initProductSwipers();
            }, 150);
          });

          // jQuery依存を排除した版
          const intervalId = window.setInterval(function() {
            var form = document.querySelector('form#productForm');
            if (!form) return;

            var disabledElements = form.querySelectorAll(':disabled');
            if (disabledElements.length > 0) {
              disabledElements.forEach(function(el) {
                el.removeAttribute('disabled');
              });
              window.clearInterval(intervalId);
            }
          }, 100);
        
  } catch(e) { console.error(e); }
})();
})();
